
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M7.09 7.59v11.59H3.23V7.58h3.86zM7.34 4c0 1.12-.84 2-2.18 2h-.03C3.83 6 3 5.13 3 4s.86-2 2.18-2c1.32 0 2.14.87 2.16 2zM21 12.53v6.65h-3.86v-6.2c0-1.56-.56-2.62-1.95-2.62-1.07 0-1.7.71-1.98 1.4-.1.25-.13.6-.13.95v6.47H9.22s.05-10.5 0-11.6h3.86v1.65a3.83 3.83 0 013.48-1.91c2.54 0 4.44 1.65 4.44 5.21z"}})])
          )
        }
      }
    